import { useEffect, useState } from 'react'

import { FilterManager } from '../../../../common/filter/FilterManager'
import { getMerchantLookupWithToken } from '../../../../common/core/_requests'
import { getPaymentMethods } from '../../../settings/api/getPaymentMethods'
import { ColumnVisibility, MatchingPayoutActiveTicketsFilters } from '../../core/_models'

type Option = { value: string; label: string }

interface Props {
  /** Истинные дефолты формы — они же цель кнопки «Сбросить». */
  defaultFilters: MatchingPayoutActiveTicketsFilters
  applyFilters: (filters: MatchingPayoutActiveTicketsFilters) => void
  visibility: ColumnVisibility
  /** Токен тикета из `?ticket=` — подставляется в поиск при первом рендере формы. */
  initialSearch?: string
}

const ActivePayoutTicketsFilter = ({
  defaultFilters,
  applyFilters,
  visibility,
  initialSearch,
}: Props) => {
  const [merchantOptions, setMerchantOptions] = useState<Option[]>([])
  const [paymentOptions, setPaymentOptions] = useState<Option[]>([])

  useEffect(() => {
    let cancelled = false

    // lookup-with-token доступен всем ролям раздела, включая ROLE_MATCHING_OPERATOR
    // (в отличие от getListMerchantsForSelect, который для оператора уходит на публичный
    // /api/merchant/list). value = токен мерчанта, label = название.
    getMerchantLookupWithToken()
      .then((resp) => {
        if (cancelled || !resp.data?.success) return
        setMerchantOptions(resp.data.data ?? [])
      })
      .catch(() => setMerchantOptions([]))

    // Опции метода — те же, что на завершённых выплатах: value/label = pm.type,
    // список уже ограничен enabled: true / hiddenFromList: false внутри getPaymentMethods.
    getPaymentMethods()
      .then((resp: any) => {
        if (cancelled || !resp?.data?.success) return
        const list = resp.data.paymentMethods ?? []
        setPaymentOptions(list.map((pm: any) => ({ value: pm.type, label: pm.type })))
      })
      .catch(() => setPaymentOptions([]))

    return () => {
      cancelled = true
    }
  }, [])

  // FilterManager читает defaultValues один раз (инициализация состояния) и использует их же как
  // цель «Сбросить». Чтобы токен из URL и попал в поле поиска, и не возвращался по «Сбросить»:
  // на первом рендере отдаём дефолты с токеном, после монтирования — истинные дефолты.
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  const filterDefaultValues = mounted
    ? defaultFilters
    : { ...defaultFilters, search: initialSearch || defaultFilters?.search }

  return (
    <FilterManager<MatchingPayoutActiveTicketsFilters>
      activeFilters={[
        { filter: 'search', visibility: !!visibility.ticketToken },
        { filter: 'selectMulti', fieldName: 'merchantTokenList', visibility: !!visibility.merchant },
        { filter: 'selectMulti', fieldName: 'paymentMethodList' },
      ]}
      defaultValues={filterDefaultValues}
      filterProps={{
        search: { label: 'Поиск', placeholder: 'ID тикета или ID транзакции' },
        merchantTokenList: { label: 'Мерчант', options: merchantOptions, placeholder: 'Все' },
        paymentMethodList: {
          label: 'Платёжный метод',
          options: paymentOptions,
          placeholder: 'Все',
        },
      }}
      onApplyFilters={applyFilters}
    />
  )
}

export default ActivePayoutTicketsFilter
